import React from 'react';

const isLikelyVideoUrl = (url = '') => /\.(mp4|mov|m4v|webm)(\?|#|$)/i.test(url);

export const PhotoVisual = ({ revealMeta = {} }) => {
  const photoState = revealMeta.photoState || {};
  const cards = photoState.cards || [];
  const hasMedia = Boolean(photoState.hasMedia);
  const positions = ['side-a', 'main', 'side-b'];
  const orderedCards = [
    cards[1] || null,
    cards[0] || null,
    cards[2] || null,
  ];

  return (
    <span
      className={`lumirae-layer-visual lumirae-layer-visual-photo${hasMedia ? ' has-media' : ' is-empty'}`}
      data-gallery-count={photoState.count || 0}
      aria-hidden="true"
    >
      {positions.map((position, index) => {
        const card = orderedCards[index];
        const isVideo = Boolean(card?.isVideo || isLikelyVideoUrl(card?.url));
        const canShowImage = Boolean(card?.url && !isLikelyVideoUrl(card.url));
        const delayByPosition = position === 'main' ? 0 : position === 'side-a' ? 90 : 180;
        return (
          <span
            key={position}
            className={`photo ${position}${card?.url ? ' has-image' : ''}${isVideo ? ' is-video' : ''}`}
            style={{ '--photo-delay': `${delayByPosition}ms` }}
          >
            {canShowImage && <img src={card.url} alt="" loading="lazy" />}
            {isVideo && <b className="play-badge" />}
            {!hasMedia && position === 'main' && <small>Add photos</small>}
          </span>
        );
      })}
      <span className="film-rail" />
    </span>
  );
};

export const ThenNowVisual = ({ revealMeta = {} }) => {
  const thenNowState = revealMeta.thenNowState || {};

  return (
    <span
      className={`lumirae-layer-visual lumirae-layer-visual-then-now${thenNowState.hasBoth ? ' has-both' : ' is-empty'}`}
      aria-hidden="true"
    >
      <span className={`compare-photo compare-then${thenNowState.hasBefore ? ' has-image' : ''}`}>
        {thenNowState.beforeUrl && <img src={thenNowState.beforeUrl} alt="" loading="lazy" />}
        <b>{thenNowState.beforeLabel || 'Then'}</b>
      </span>
      <span className={`compare-photo compare-now${thenNowState.hasAfter ? ' has-image' : ''}`}>
        {thenNowState.afterUrl && <img src={thenNowState.afterUrl} alt="" loading="lazy" />}
        <b>{thenNowState.afterLabel || 'Now'}</b>
      </span>
      <span className="compare-divider">
        <i />
      </span>
    </span>
  );
};

export const FrameGalleryVisual = ({ revealMeta = {} }) => {
  const frameState = revealMeta.frameGalleryState || {};
  const frameStyle = frameState.frameStyle || 'paper';

  return (
    <span
      className={`lumirae-layer-visual lumirae-layer-visual-frame-gallery is-${frameStyle}${frameState.hasImage ? ' has-image' : ' is-empty'}`}
      aria-hidden="true"
    >
      <span className="frame-shadow" />
      <span className="frame-mat">
        {frameState.imageUrl ? (
          <img src={frameState.imageUrl} alt="" loading="lazy" />
        ) : (
          <span className="empty-art" />
        )}
      </span>
      <span className="frame-caption">{frameState.caption || 'A framed memory'}</span>
    </span>
  );
};
